
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path d="M13.8048 21.1612L6.5403 15.7128H2V8.44835H6.5403L13.8048 3V21.1612Z"></path><path d="M16.983 7.39743L17.6901 8.10454C19.8967 10.3112 19.8967 13.7593 17.6901 15.966L16.983 16.6731L15.5688 15.2589L16.2759 14.5518C17.7015 13.1262 17.7015 10.9443 16.2759 9.51875L15.5688 8.81165L16.983 7.39743Z"></path><path d="M20.3234 5.65263L19.6163 4.94553L18.2021 6.35974L18.9092 7.06685C21.6969 9.85453 21.6969 14.3973 18.9092 17.185L18.2021 17.8921L19.6163 19.3063L20.3234 18.5992C23.8922 15.0305 23.8922 9.22137 20.3234 5.65263Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowaudioFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
